import React, { Component } from "react";

export default class transcripts extends Component {
  render() {
    return (
      <React.Fragment>
        <div>You need to send the Transcripts to the university. You will have a hold on registration until you submit them</div>
        <br />
        <div>
          <ul>
            <li>
              You may have already submitted the unofficial transcript. This is the pdf copy you uploaded while submitting your applicaion
            </li>
            <li>
              The university, however, needs you to submit the official transcript to the university via post. They need the physical copy
              of the transcripts
            </li>
            <li>
              Official transcripts may be mailed to the university from your school, mailed to the university by you, or else brought to the
              university in person.
            </li>
            <li>Official transcripts must remain sealed in the issuing institution's envelope to be considered official.</li>
            <li>
              You can request your current university where you are doing/did the master to send you the transcript and courier it to UGA
            </li>
            <li>
              The address to send your transcript:
              <br />
              <br />
              <pre>UGA Graduate Admissions</pre>
              <pre>Brooks Hall 335</pre>
              <pre>310 Herty Drive</pre>
              <pre>Athens, GA 30602-6254</pre>
            </li>
            <li>
              You may also need to provide your degree certificate (<i>You can inquire about this after your transcripts are submitted</i>)
            </li>
          </ul>
          <br />
          You can find more details here:{" "}
          <a
            href="http://grad.uga.edu/index.php/prospective-students/domestic-application-information/requirements/transcripts-and-academic-records/"
            target={"_blank"}
            rel={"noreferrer"}
            style={{ textDecoration: "underline" }}
            className="redLink"
          >
            Transcript details
          </a>
        </div>
      </React.Fragment>
    );
  }
}
